import React from 'react'

import { PendenciasDocumentosAluno } from 'src/tipos'

import {
  BarraFundo,
  BarraPreenchida,
  Consequencia,
  Contador,
  Titulo,
  Wrapper
} from './cabecalho-documentos-obrigatorios.styles'

interface Props {
  pendencias: PendenciasDocumentosAluno | null
  textoDiploma: string
}

export const CabecalhoDocumentosObrigatorios: React.FC<Props> = ({
  pendencias,
  textoDiploma
}) => {
  const total = pendencias?.totalObrigatorios ?? 0
  const enviados = pendencias?.enviados ?? 0
  const faltam = pendencias?.pendentes?.length ?? 0
  const percentual = total > 0 ? Math.round((enviados / total) * 100) : 0
  const mostrarPendencia = Boolean(pendencias?.exigeDocumentos)

  return (
    <Wrapper>
      <Titulo>Documentos obrigatórios para o certificado</Titulo>
      {mostrarPendencia && (
        <>
          <Contador>
            {faltam > 0
              ? `Faltam ${faltam} documentos obrigatórios`
              : 'Todos os documentos obrigatórios foram enviados'}
          </Contador>
          <BarraFundo>
            <BarraPreenchida percentual={percentual} />
          </BarraFundo>
          <Contador>
            {enviados} de {total} enviados
          </Contador>
          {faltam > 0 && (
            <Consequencia>
              Sem eles o certificado não é emitido. {textoDiploma}
            </Consequencia>
          )}
        </>
      )}
    </Wrapper>
  )
}
